<template>
  <div class="wechat-list page-box">
    <query-header
      ref="header"
      @toQuery="toQuery"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              所属服务器
            </vs-th>
            <vs-th>
              名称
            </vs-th>
            <vs-th>
              监听端口
            </vs-th>
            <vs-th>
              微信ID
            </vs-th>
            <vs-th>
              昵称
            </vs-th>
            <vs-th>
              头像
            </vs-th>
            <vs-th>
              监听状态
            </vs-th>
            <vs-th>
              登录状态
            </vs-th>
            <vs-th>
              状态
            </vs-th>
            <vs-th>
              备注
            </vs-th>
            <vs-th>
              创建时间
            </vs-th>
            <vs-th>
              更新时间
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
            >
              <vs-td
                style="min-width: 50px;"
              >
                {{tr.id}}
              </vs-td>
              <vs-td
                style="min-width: 120px"
              >
                <div>{{tr.apiName}}</div>
                <div>{{tr.apiType==1?'DLL':'Wechaty'}}</div>
              </vs-td>
              <vs-td>
                {{tr.botName}}
              </vs-td>
              <vs-td
                style="min-width: 100px"
              >
                {{tr.botPort || '-'}}
              </vs-td>
              <vs-td
                style="max-width: 120px"
              >
                {{tr.wxId ||'-'}}
              </vs-td>
              <vs-td>
                {{tr.nickname || '-'}}
              </vs-td>
              <vs-td>
                <img
                  class="headimg"
                  :src="tr.headImgUrl || defaultAvatar"
                />
              </vs-td>
              <vs-td
                style="min-width: 100px"
              >
                {{tr.monitorStatus == 0?'未监听':'监听中'}}
              </vs-td>
              <vs-td
                style="max-width: 240px"
              >
                <div>{{tr.loginStatus==0?'离线':'在线'}}</div>
                <span class="">{{getLoginText(tr)}}</span>
              </vs-td>
              <vs-td
                style="min-width: 100px"
              >
                <span
                  class="self-tag"
                  :style="getStyle(tr)"
                >
                  {{tr.botStatus == 0
                  ?'禁用'
                  :'启用'}}
                </span>
              </vs-td>
              <vs-td>
                {{tr.remark}}
              </vs-td>
              <vs-td>
                {{parseTime(tr.createTime)}}
              </vs-td>
              <vs-td>
                {{parseTime(tr.updateTime)}}
              </vs-td>
              <vs-td
                style="min-width: 180px"
              >
                <el-button
                  type="text"
                  v-if="isAuth('wx:bot:client:update')"
                  class="do-btn search-btn"
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  v-if="isAuth('wx:bot:client:login')"
                  type="text"
                  class="do-btn search-btn"
                  @click="loginHandle(tr)"
                >登录</el-button>
                <el-button
                  v-if="isAuth('wx:bot:client:logout')"
                  type="text"
                  class="do-btn search-btn"
                  @click="loginoutHandle(tr)"
                >下线</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <edit-dialog
      :form-data="currentRow"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editUserSuccess"
    ></edit-dialog>
    <qr-code-dialog
      :login-bot-id="loginBotId"
      :login-qr-code="loginQrCode"
      :dialog-show="qrCodeDialogShow"
      @close="closeQrCodeDialog"
      @refresh-success="refreshSuccess"
    ></qr-code-dialog>
    <login-confirm-dialog
      :dialog-show="loginConfirmDialogShow"
      :row-data="currentRow"
      @close="closeLoginConfirmDialog"
      @confirm-success="loginConfirmSuccess"
    ></login-confirm-dialog>
  </div>
</template>

<script>
import defaultAvatar from '../../../assets/images/defaultAvatar.png'
import loginConfirmDialog from "@/components/wechat/wechat-list/loginConfirmDialog";
import qrCodeDialog from "@/components/wechat/wechat-list/qrCodeDialog";
import editDialog from "@/components/wechat/wechat-list/editDialog";
import queryHeader from "@/components/wechat/wechat-list/queryHeader";
import { mapGetters } from 'vuex'
import {colorRgba, parseTime} from '@/utils'
import initData from "@/mixins/initData";
import { loginOutWechat } from "@/api/wechat/wechat-list";
export default {
  name: "index",
  components: {
    queryHeader,
    editDialog,
    qrCodeDialog,
    loginConfirmDialog,
  },
  data() {
    return {
      editDialogShow: false,
      currentRow: {},
      loginBotId: 0,
      loginLoading: false,
      loginQrCode: '',
      qrCodeDialogShow: false,
      loginConfirmDialogShow: false,
      defaultAvatar: defaultAvatar,
      red: '#D85E5F',
      green: '#41B883',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    getStyle(tr){
      if(tr.botStatus === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        }
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    beforeInit(){
      this.url = '/wx/manage/wxBotClientInfo/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc',
      }
      let header = this.$refs.header;
      if(header.botName){
        this.params.botName = header.botName;
      }
      if(header.status !== ''){
        this.params.loginStatus = header.status;
      }
      if(header.monitorStatus !== ''){
        this.params.monitorStatus = header.monitorStatus;
      }
      if(header.botStatus !== ''){
        this.params.botStatus = header.botStatus;
      }

      return true;
    },
    getLoginText(tr){
      return tr.loginStatus==0
        ?"离线时间：" + parseTime(tr.offlineTime)
        : "上线时间：" + parseTime(tr.loginTime)
    },
    editHandle(tr){
      this.currentRow = tr;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    closeEditDialog(){
      this.currentRow = {};
      this.editDialogShow = false;
    },
    editUserSuccess(){
      this.currentRow = {};
      this.editDialogShow = false;
      this.searchHandle();
    },
    loginHandle(data){
      this.loginBotId = data.id;
      this.currentRow = data;
      this.loginConfirmDialogShow = true;
    },
    loginoutHandle(data){
      this.$confirm(`确定对[${data.botName}]进行下线操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        loginOutWechat(data.id).then((res) => {
          if (res && res.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.page = 1;
                this.init()
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => { })
    },
    closeQrCodeDialog(){
      this.qrCodeDialogShow = false;
    },
    closeLoginConfirmDialog(){
      this.currentRow = {};
      this.loginConfirmDialogShow = false;
    },
    loginConfirmSuccess(res){
      this.currentRow = {};
      this.loginConfirmDialogShow = false;
      this.editDialogShow = false
      // 打开二维码弹框
      this.loginQrCode = res.qrCode;
      setTimeout(() => {
        this.editDialogShow = true;
      },200)
    },
    refreshSuccess(res){
      this.loginQrCode = res.qrCode;
    }
  },
}
</script>

<style lang="scss" scoped>
.wechat-list {
  .headimg{
    width: 50px;
    height: 50px;
    border-radius: 8px;
  }
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1400px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }

}
</style>
